import TranslationService from "@/shared/services/translation.service";
import { Component, Inject, Mixins, Vue } from "vue-property-decorator";
import GlobalService from "../services/global.service";
import { GameTypes } from "@/shared/constants/gametypes.constants";
import Currencies from "@/shared/constants/currencies.constants";
import { IUserUI } from "@/shared/model/user-management/userUI.model";
import { IYmlConstants } from "@/shared/model/global/yml-constants.model";
import UtilityMixin from "./utility-mixin";

@Component
class GlobalMixin extends Mixins(UtilityMixin) {
  @Inject("globalService") public globalService: () => GlobalService;
  @Inject("translationService") public translationService: () => TranslationService;

  public gameType;
  public user: IUserUI;

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public changeCurrency(newCurrency) {
    this.translationService().refreshCurrency(newCurrency);
  }

  get isAdmin() {
    const account = this.$store.getters.account;
    return account == null ? false : account.authorities.indexOf("ROLE_ADMIN") > -1
  }

  // company 1 is shared by LinkedIn sign-ups, franchisees get the logo of their franchisor
  get canEditCompanyLogo() {
    const account = this.$store.getters.account;
    const user = this.$store.getters.user;
    if (account == null || user == null) return false;
    const isFranchised = user.franchisorId && user.franchisorId != user.companyId;
    return account.authorities.indexOf("ROLE_DIRECTOR") > -1 && user.companyId != 1 && !isFranchised;
  }

  get onDev() {
    return process.env.NODE_ENV == "development";
  }

  public get currency() {
    let currency = this.$store.getters.currency;
    let display = Object.values(Currencies).find((el) => el.value == currency).display;
    return display;
  }

  get profilePicture() {
    let user = this.$store.getters.user;
    if (user == null) return null;
    else if (!user.profilePicture) return null;
    else return user.profilePicture;
  }

  /*
   * Check if advisor has reached limit of quiz creation depending on his offer
   */
  public limitReached(gameType) {
    switch (gameType) {
      case GameTypes.ESG:
        return this.user.limitReachedEsg;
      case GameTypes.GAME360:
        return this.user.limitReached360;
      case "both":
        return this.user.limitReached360 && this.user.limitReachedEsg;
    }
  }

  public linkedInLink(cookieOptionalAccepted: boolean) {
    let clientId = "78noxxj6iur4ig";
    let activeProfiles = this.$store.getters.activeProfiles;

    let start = "https://www.linkedin.com/oauth/v2/authorization?response_type=code";
    let end = "/login/oauth2/code/linkedin&state=foobar&scope=r_liteprofile%20r_emailaddress";

    let redirect;
    if (activeProfiles.indexOf("prod") > -1) {
      redirect = "https://place.odonatech.com";
    } else if (activeProfiles.indexOf("test") > -1) redirect = "https://place-test.cleverapps.io";
    else redirect = "http://localhost:9000";

    let uri = `${start}&client_id=${clientId}&redirect_uri=${redirect}${end}`;
    this.deleteCookieAndCreateOnePlusgtag(cookieOptionalAccepted);
    window.location.href = uri;
  }

  public deleteCookieAndCreateOnePlusgtag(cookieOptionalAccepted) {
    let cookieName = "cookie_choice_opt";
    let choice = this.$cookies.get(cookieName);
    if (choice !== undefined) this.$cookies.remove(cookieName);

    let consent = {
      ad_storage: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      security_storage: "granted",
    };
    if (!cookieOptionalAccepted) {
      consent = {
        ad_storage: "denied",
        analytics_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted",
      };
    }
    this.$cookies.set("cookie_choice_opt", consent, 60 * 60 * 24 * 30 * 2);
    this.startGtagTracking(consent);
  }

  logout() {
    console.log("logging out");
    localStorage.removeItem("jhi-authenticationToken");
    sessionStorage.removeItem("jhi-authenticationToken");
    this.$store.commit("logout");
    this.sendCustomEvent("JhiUserMenu.Logout", null);
    this.$router.push("/");
  }

  /*
   * redirect after authentication, dashboard for users & admin panel for admin
   */
  public redirect() {
    if (!this.isAdmin) this.$router.replace("/platform#dashboard");
    else this.$router.replace("/admin");
  }

  public sendPageView(title) {
    if (
      process.env.NODE_ENV == "development" ||
      this.$store.getters.activeProfiles.indexOf("test") > -1 ||
      this.$store.getters.activeProfiles.indexOf("preprod") > -1
    )
      return;

    let dataLayer = window["dataLayer"];
    dataLayer.push({ event: "odo.pageView", "odo.pageTitle": title, "odo.pagePath": this.$route.path });
  }

  public sendCustomEvent(type, object) {
    if (
      process.env.NODE_ENV == "development" ||
      this.$store.getters.activeProfiles.indexOf("test") > -1 ||
      this.$store.getters.activeProfiles.indexOf("preprod") > -1
    )
      return;

    let dataLayer = window["dataLayer"];
    if (object != null) {
      // seems to never be used
      dataLayer.push({ event: "odo." + type, value: object });
    } else {
      dataLayer.push({ event: "odo.click", "odo.elementIdOld": type });
    }
  }

  public async startGtagTracking(object) {
    if (
      process.env.NODE_ENV == "development" ||
      this.$store.getters.activeProfiles.indexOf("test") > -1 ||
      this.$store.getters.activeProfiles.indexOf("preprod") > -1
    )
      return;

    // update GTM consent
    let gtag = window["gtag"];
    gtag("consent", "update", object);
  }

  public analyticsInvite(mean, gameType, analyticType) {
    if (
      process.env.NODE_ENV == "development" ||
      this.$store.getters.activeProfiles.indexOf("test") > -1 ||
      this.$store.getters.activeProfiles.indexOf("preprod") > -1
    )
      return;

    let name = "Odona" + gameType.toUpperCase() + "." + analyticType;
    let send;
    if (mean.toUpperCase() == "SMS") send = name + "SMS";
    else send = name + "MAIL";
    this.sendCustomEvent(send, null);
  }

  public sendDataLayerClickEvent(type) {
    if (
      process.env.NODE_ENV == "development" ||
      this.$store.getters.activeProfiles.indexOf("test") > -1 ||
      this.$store.getters.activeProfiles.indexOf("preprod") > -1
    )
      return;

    let dataLayer = window["dataLayer"];
    dataLayer.push({ event: "odo.click", "odo.elementId": type });
  }

  /*
   * get some of the .yml conf constants from the backend
   */
  public async setYmlConstants() {
    try {
      let constants: IYmlConstants = await this.globalService().getYmlConstants();
      this.$store.commit("setYmlConstants", constants);
    } catch (error) {
      throw error;
    }
  }

  public getPublicLink(app) {
    if (app == "facettes")
      return `${this.$store.getters.profileUrl}/360/public/${this.$store.getters.user.encodedId}/facettes`;
    return `${this.$store.getters.profileUrl}/${app}/public/${this.$store.getters.user.encodedId}`;
  }

  public get o2sStartDate() {
    return new Date(this.$store.getters.o2sStartDate);
  }
}
export default GlobalMixin;
